import "./assets/css/style.css";
import { useEffect, useState } from "react";
import AppRoute from "./config/Routes";
import { createTheme, ThemeProvider } from "@material-ui/core";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { connect } from "react-redux";
import { check_current_user } from "./store/actions"
import Loader from './Components/others/Loader';


// material Ui color config
const colors = {
  primary: "#103b55",
  "primary-light": "#103b55",
  "primary-dark": "#226691",
  secondary: "#92B9D5",
  "secondary-light": "#92B9D5",
  "secondary-dark": "#92B9D5",
};

// ================= Initialized  Material Ui theme Globally for the web  ===================
const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
      light: colors["primary-light"],
      dark: colors["primary-dark"],
      contrastText: `#fff`,
    },
    secondary: {
      contrastText: `#fff`,
      main: colors.secondary,
      light: colors["secondary-light"],
      dark: colors["secondary-dark"],
    },
  },
  typography: {
    fontFamily: `"Times New Roman", "Times", serif`,
    fontWeightBold: 900,
    fontWeightLight: 700,
    fontWeightMedium: 600,
    fontWeightRegular: 550,
    h1: {
      fontSize: `3rem`,
    },
    h2: {
      fontSize: `2.5rem`,
    },
    h3: {
      fontSize: `2rem`,
    },
    h4: {
      fontSize: `1.75rem`,
    },
    h5: {
      fontSize: `1.5rem`,
    },
    h6: {
      fontSize: `1.25rem`,
    },
  },
});

// =====================
function App(props) {
  const [loaded, setLoaded] = useState(false);
  // check loggedIn user
  useEffect(() => {
    props.check_current_user();
    console.clear();
    console.warn = () => { };

    let loader = setTimeout(() => {
      setLoaded(true)
    }, 1500);

    return loader
  }, []) //eslint-disable-line no-unused-vars


  

  return (
    <ThemeProvider theme={theme}>
      {loaded ?
        <AppRoute />
        : <Loader type="webLoader" />}
      <GoToTop />
    </ThemeProvider>
  );
}


// Go to Top of the page Button
const GoToTop = () => {
  // =============== check when go to top button have to visible =============================
  window.onscroll = function () {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
    let btn = document.getElementById('scrollToTop');
    if (btn) {
      if (pageOffset > 450) {
        btn.classList.add('show-top')
      } else {
        btn.classList.remove('show-top')
      }
    }
  }

  //====================== go top function ================
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  return (
    <div onClick={goToTop} className="go-to-top" id="scrollToTop">
      <ArrowUpwardIcon />
    </div>
  )
}


// Redux config
const mapDispatchToProps = (dispatch) => ({
  check_current_user: () => dispatch(check_current_user()),
});

export default connect(null, mapDispatchToProps)(App);
